/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientAddressesViewModel } from './PatientAddressesViewModel'; 

export function getPatientAddressesOptions(stayId: string, onSuccess?: (result: PatientAddressesViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-addresses', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/addresses/queries/getpatientaddresses/' + stayId;
			const resp = await axios.get<PatientAddressesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}